export default __webpack_public_path__ + "static/media/performanceEvaluation.57273f6c.svg";